import { normalizeMenuPath } from '~/composables/useClinicMenu';
import { RELEASE_FEATURES } from '~/utils/releaseFeatures';

export interface ClientOwnerMenuItem {
  link: string;
  name: string;
  isHome?: boolean;
  badge?: string;
  separatorAfter?: boolean;
}

export const CLIENT_OWNER_HOME_LABEL = 'Ветеринарная карта';
export const CLIENT_OWNER_HOME_BADGE = 'NEW';

export const CLIENT_OWNER_MENU_ITEMS: ClientOwnerMenuItem[] = [
  { link: '/profile/ai/', name: 'ИИ-помощник', badge: CLIENT_OWNER_HOME_BADGE },
  { link: '/profile/documents/', name: 'Документы и анализы' },
  { link: '/profile/history/', name: 'Консультации и записи' },
  { link: '/profile/orders/', name: 'Заказы', separatorAfter: true },
  { link: '/profile/edit/', name: 'Мой профиль' },
].filter((item) => RELEASE_FEATURES.aiVet || item.link !== '/profile/ai/');

export const CLIENT_OWNER_MOBILE_MENU_ITEMS: ClientOwnerMenuItem[] = [
  {
    link: '/profile/',
    name: CLIENT_OWNER_HOME_LABEL,
    isHome: true,
    badge: CLIENT_OWNER_HOME_BADGE,
  },
  ...CLIENT_OWNER_MENU_ITEMS,
];

/** Число на пункте «Заказы». Ноль и чужие пункты бейдж не получают. */
export function clientOwnerOrdersBadge(link: string, count: number | null | undefined): string | undefined {
  if (normalizeMenuPath(link) !== '/profile/orders/' || !count || count < 1) {
    return undefined;
  }

  return String(count);
}

export function isClientOwnerMenuItemActive(routePath: string, item: ClientOwnerMenuItem): boolean {
  if (item.isHome) {
    return normalizeMenuPath(routePath) === '/profile/';
  }

  return normalizeMenuPath(routePath).startsWith(normalizeMenuPath(item.link));
}
